export const navData = {
  ourStory: {
    title: 'Our Story',
    slug: '/our-story',
    items: [
      {
        title: 'Clayton Values',
        subtitle: '',
        url: '/our-story#built-on-values',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Quality Craftsmanship',
        subtitle: '',
        url: '/our-story#craftsmanship',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Innovation',
        subtitle: '',
        url: '/our-story#innovation',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Sustainability',
        subtitle: '',
        url: '/our-story#sustainability',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
    ],
  },
  ourStandards: {
    title: 'Our Standards',
    slug: '/our-standards',
    items: [
      {
        title: 'eBuilt®',
        subtitle: '',
        url: '/ebuilt',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'ENERGY STAR®',
        subtitle: '',
        url: '/our-standards#energy-star',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Construction',
        subtitle: '',
        url: '/our-standards#construction',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Amenities',
        subtitle: '',
        url: '/our-standards#amenities',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
    ],
  },
  ourHomes: {
    title: 'Our Homes',
    slug: '/our-homes',
    items: [
      {
        title: 'Manufactured',
        subtitle: '',
        url: '/manufactured',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Park Models',
        subtitle: '',
        url: '/our-homes#park-models',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'CrossMod®',
        subtitle: '',
        url: '/crossmod',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Modular',
        subtitle: '',
        url: '/our-homes#modular',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
    ],
  },
  ourBrandPartners: {
    title: 'Our Brand Partners',
    slug: '/our-brand-partners',
    items: [
      {
        title: 'Carrier®',
        subtitle: '',
        url: '/our-brand-partners/carrier',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'DuraCraft®',
        subtitle: '',
        url: '/our-brand-partners/duracraft',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'ecobee',
        subtitle: '',
        url: '/our-brand-partners/ecobee',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Frigidaire®',
        subtitle: '',
        url: '/our-brand-partners/frigidaire',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Kwikset®',
        subtitle: '',
        url: '/our-brand-partners/kwikset',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Lux®',
        subtitle: '',
        url: '/our-brand-partners/lux',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Pfister®',
        subtitle: '',
        url: '/our-brand-partners/pfister',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Rheem®',
        subtitle: '',
        url: '/our-brand-partners/rheem',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Samsung®',
        subtitle: '',
        url: '/our-brand-partners/samsung',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Shaw®',
        subtitle: '',
        url: '/our-brand-partners/shaw',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'More Partners',
        subtitle: '',
        url: '/our-brand-partners#more-partners',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
    ],
  },
  about: {
    title: 'About Us',
    slug: '/about',
    items: [
      {
        title: 'Clayton Home Building Group',
        subtitle: '',
        url: 'https://www.claytonhomebuildinggroup.com',
        openNewWindow: true,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Opening Doors Magazine',
        subtitle: '',
        url: 'https://www.claytonhomebuildinggroup.com/opening-doors-magazine',
        openNewWindow: true,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Careers',
        subtitle: '',
        url: 'https://careers.claytonhomes.com/',
        openNewWindow: true,
        isHeader: true,
        isFooter: true,
      },
      {
        title: 'Contact Us',
        subtitle: '',
        url: '/contact-us',
        openNewWindow: false,
        isHeader: true,
        isFooter: true,
      },
    ],
  },
};
